import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "rnFormatLowercaseNoSpace",
    standalone: false
})
export class RnFormatLowercaseNoSpacePipe implements PipeTransform {
  transform(value: string): string {
      return value.replace(/\s+/g, "").toLowerCase();
  }
}
